var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9H6C5.17266 9 4.5 8.32734 4.5 7.5V1.5C4.5 0.672656 5.17266 0 6 0H9.28359C9.58125 0 9.86719 0.119531 10.0781 0.330469L11.6695 1.92188C11.8805 2.13281 12 2.41875 12 2.71641V7.5C12 8.32734 11.3273 9 10.5 9ZM1.5 3H3.75V4.125H1.5C1.29375 4.125 1.125 4.29375 1.125 4.5V10.5C1.125 10.7063 1.29375 10.875 1.5 10.875H6C6.20625 10.875 6.375 10.7063 6.375 10.5V9.75H7.5V10.5C7.5 11.3273 6.82734 12 6 12H1.5C0.672656 12 0 11.3273 0 10.5V4.5C0 3.67266 0.672656 3 1.5 3Z",
    fill: "#626F86"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicateIcon.5d1c2d6bc0ed8acc9ac2eb3e4a923626.svg";
export { ForwardRef as ReactComponent };